'use client';

import SignupModal from '@/components/_rebrand/TrialForm/Modal';
import { OPTIMIZELY_PAGES } from '@/constants/optimizely';
import optimizely from '@/lib/optimizely';
import useStore from '@/stores/useStore';
import { FC, useEffect } from 'react';
interface SignupModalProps {
  onClose?: () => void;
}

const TrialModal: FC<SignupModalProps> = () => {
  const { isTrialModalOpen, setTrialModalOpen } = useStore();

  useEffect(() => {
    if (isTrialModalOpen) {
      const deactivate1 = optimizely.activatePage(OPTIMIZELY_PAGES.ANY_GET_STARTED_MODAL);
      const deactivate2 = optimizely.activatePage(OPTIMIZELY_PAGES.TRIAL_MODAL);

      return () => {
        deactivate1();
        deactivate2();
      };
    }
  }, [isTrialModalOpen]);

  return isTrialModalOpen ? (
    <SignupModal
      onClose={() => {
        setTrialModalOpen(false);
      }}
    />
  ) : null;
};

export default TrialModal;
